import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MobileModalService {
  private dismissedKey: string | null = null;

  // Emits true/false depending on whether modal should be visible
  public visible$ = new BehaviorSubject<boolean>(false);

  init(storageKey: string) {
    this.dismissedKey = storageKey;
    this.updateVisibility();
  }

  private updateVisibility() {
    if (!this.dismissedKey) return;
    const dismissed = localStorage.getItem(this.dismissedKey) === '1';
    this.visible$.next(!dismissed);
  }

  dismissForever() {
    if (!this.dismissedKey) return;
    localStorage.setItem(this.dismissedKey, '1');
    this.visible$.next(false);
  }
}
